import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import React from 'react';
import { FormContext } from '../context/FormContext';
import searchFields from './searchFields';
import updateFields from './updateFields';
import editField from './editField';
import searchAndUpdateFields from './searchAndUpdateFields';
import loadFormData from '../logic/data/formDataLoader';
import loadFormContext from '../logic/data/formContextLoader';
import resolveFormDataBinding from '../logic/data/formDataBinding';
import validation from '../validation';
import ACTIONS from '../logic/actions';
import formData from '../logic/formData';
/**
 * @returns {import('./types').EcrionFormApi}
 */

var useFormAPI = function useFormAPI() {
  var _React$useContext = React.useContext(FormContext),
      _React$useContext2 = _slicedToArray(_React$useContext, 2),
      state = _React$useContext2[0],
      dispatch = _React$useContext2[1];

  var loadData = function loadData(form) {
    return loadFormData(state, form, dispatch);
  };

  var loadContext = function loadContext(contactId, runParameters) {
    return loadFormContext(state, contactId, runParameters, dispatch);
  };

  var loadBinding = function loadBinding() {
    return resolveFormDataBinding(state, dispatch);
  };

  var setPristine = function setPristine() {
    var dirty = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return dispatch({
      type: ACTIONS.SET_FORM_DIRTY,
      payload: dirty
    });
  };
  /** @type {import('./types').ValidateFunction} */


  var validate = function validate() {
    return validation.validateForm(state, dispatch);
  };
  /** @type {import('./types').GetFormDataFunction} */


  var getData = function getData(trackingData) {
    return formData.getFormXml(state, trackingData);
  };
  /** @type {import("./types").SearchFieldsFunction} */


  var search = function search(options) {
    return searchFields(state, options);
  };
  /** @type {import("./types").UpdateFieldsFunction} */


  var update = function update(options) {
    return updateFields(state, dispatch, options);
  };
  /** @type {import('./types').EditFieldFunction} */


  var edit = function edit(field) {
    return editField(state, dispatch, field);
  };
  /** @type {import('./types').SearchAndUpdateFieldsFunction} */


  var searchAndUpdate = function searchAndUpdate(options) {
    return searchAndUpdateFields(state, dispatch, options);
  };

  return {
    loading: state.stage !== 'loaded',
    state: state,
    dispatch: dispatch,
    loadData: loadData,
    loadContext: loadContext,
    loadBinding: loadBinding,
    setPristine: setPristine,
    getData: getData,
    validate: validate,
    editField: edit,
    searchFields: search,
    updateFields: update,
    searchAndUpdateFields: searchAndUpdate
  };
};

export default useFormAPI;